'use client'

import { useState } from 'react'

export default function GatePage() {
	const [password, setPassword] = useState('')
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(false)

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault()
		setLoading(true)
		setError(false)

		const res = await fetch('/api/gate', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ password }),
		})

		if (res.ok) {
			window.location.href = '/'
		} else {
			setError(true)
			setLoading(false)
		}
	}

	return (
		<div className="flex min-h-screen items-center justify-center bg-black">
			<form
				onSubmit={handleSubmit}
				className="flex w-full max-w-sm flex-col gap-4 rounded-lg border border-white/10 bg-white/5 p-8"
			>
				<h1 className="font-grotesk text-center text-xl font-semibold text-white">
					OnAutopilot
				</h1>
				<p className="text-center text-sm text-white/50">
					Enter the password to continue
				</p>
				<input
					type="password"
					value={password}
					onChange={e => setPassword(e.target.value)}
					placeholder="Password"
					autoFocus
					className="rounded-md border border-white/10 bg-white/5 px-4 py-2.5 text-sm text-white placeholder-white/30 outline-none focus:border-white/25"
				/>
				{error && (
					<p className="text-center text-sm text-red-400">
						Wrong password
					</p>
				)}
				<button
					type="submit"
					disabled={loading || !password}
					className="rounded-md bg-white px-4 py-2.5 text-sm font-medium text-black transition hover:bg-white/90 disabled:opacity-50"
				>
					{loading ? 'Checking...' : 'Enter'}
				</button>
			</form>
		</div>
	)
}
